import { useCallback } from 'react';
import { SkippableFragment } from '@funtech-int/kp-graphql-sdk/yango-movies-www';

import { useSkipWithAnalytics } from '../../../../hooks/skin/use-skip';
import { useSwitchToNextEpisodeWithAnalytics } from '../../../../hooks/skin/use-switch-to-next-episode-with-analytics';

export const useCreditSkip = (
    contentId: string,
    currentFragment: SkippableFragment | undefined
) => {
    const skip = useSwitchToNextEpisodeWithAnalytics(contentId);

    const manualSkip = useCallback(() => {
        skip('NEXT_EPISODE_SELECT_SKIP', currentFragment?.type ?? 'UNKNOWN');
    }, [currentFragment?.type, skip]);

    return {
        ...useSkipWithAnalytics(currentFragment),
        skip: manualSkip,
    };
};
